// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__+nPRX","header":"Layout_header__TyB9T","logo":"Layout_logo__E+6TJ","collapsed":"Layout_collapsed__NwMZD","content":"Layout_content__UOgH6"};